import { createSelector } from 'reselect'
import { Map } from 'immutable'
import * as constants from './constants'
import { orgUsersById, currentUser } from 'app/modules/user/selectors'
import { UserStatus } from 'app/modules/user/constants'

export const root = (state) => state.get('userProperties')

export const propertiesLoaded = (state) => root(state).getIn(['status', 'fetch']) === constants.RECEIVE_USER_PROPERTIES
export const fetchPropertiesFailed = (state) => root(state).getIn(['status', 'fetch']) === constants.FETCH_USER_PROPERTIES_FAILED
export const properties = (state) => root(state).get('data', Map())
export const extensionProperties = (state) => properties(state).get('extensionSettings')
export const usersByPropertyName = (state) => root(state).get('usersByPropertyName')
export const isUserAtConversationLimit = createSelector(properties, props => props.get('atConversationLimit'))

const alwaysTrue = () => true
export const makeUsersWithProperty = (property, matcher = alwaysTrue) => {
  return createSelector([
    usersByPropertyName,
    orgUsersById,
  ], (
    usersByPropertyName,
    orgUsersById,
  ) => {
    return usersByPropertyName.get(property, Map())
      .filter((entry) => {
        return matcher(entry.get('value'), entry.get('updatedAt'))
      })
      .map((entry, userId) => orgUsersById.get(userId))
      .filter((user) => !!user)
      .filter((user) => user.status === UserStatus.ENABLED)
  })
}

const CONTACT_SIDEBAR_REDESIGN_FULCRUM_DATE = new Date('2018-7-18')

export const isCurrentUserEligibleForContactSidebarRedesignAnnouncement = createSelector(
  [
    currentUser,
    properties,
  ],
  (user, userProperties) => {
    return (
      (user && (user.createdAt <= +CONTACT_SIDEBAR_REDESIGN_FULCRUM_DATE)) &&
      (userProperties && !userProperties.get('did_acknowledge_contact_sidebar_redesign'))
    )
  })

export const hasCompactViewEnabled = createSelector(properties,
  (properties) => properties && properties.get('hasCompactConversationListItemExperiment') && properties.get('isCompactViewEnabled'))

export const isConversationStatusDisabled = createSelector(properties,
  (properties) => properties && properties.get('isConversationStatusDisabled'))

export const hasUnreadsOnly = createSelector(properties,
  (properties) => properties && properties.get('hasUnreadsOnly'))

export const isUnreadsOnlyEnabled = createSelector(properties,
  (properties) => properties && properties.get('isUnreadsOnlyEnabled'))

export const videoSignUpDone = createSelector(properties,
  (properties) => properties && properties.get('videoSignUpDone'))

export const isDesktopUser = createSelector(properties,
  (properties) => properties && properties.get('has_desktop_app') && properties.get('has_desktop_app') !== "false")



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/properties/selectors.js